import React, { createRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import BaseActionForm from '../BaseActionForm';
import { Button } from "react-bootstrap";
import './styles.scss'
import BackArrow from './../../assets/BackArrow.svg'

import LeftPanelHeader from './../../components/LeftPanelHeader';
import * as actionTypes from "../../services/StoreContainer/actionTypes";

import Map from "./../../components/OpenLayers/Map";
import { fromLonLat, toLonLat } from "ol/proj";
import { vector, xyz } from "./../../components/OpenLayers/Source";
import { TileLayer, VectorLayer } from "./../../components/OpenLayers/Layers";
import { Style, Icon, Stroke, Fill } from "ol/style";
import GeoJSON from 'ol/format/GeoJSON';
import { Modify, Select, Draw, defaults as defaultInteractions } from 'ol/interaction';

export default function GeometryEditor(props) {
    const dispatch = useDispatch();
    const datasetsContainer = useSelector((store) => { return store.datasetsReducer })

    return <GeometryEditorClass
        {...props}
        dispatch={dispatch}
        datasetsContainer={datasetsContainer}
    />
}

class GeometryEditorClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.mapRef = createRef();

        this.select = new Select({ wrapX: false });
        this.modify = new Modify({ features: this.select.getFeatures() });

        this.state = {
            ...this.state,
            runningOperation: null
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        let dataset = this.props.datasetsContainer.selectedDataset;

        let wgsGeometry = this.props.object;
        let fieldParts = this.props.field.split('.');
        fieldParts.forEach((part) => {
            if (wgsGeometry) {
                wgsGeometry = wgsGeometry[part];
            }
        });
        if (wgsGeometry) {
            let bounds = this.getBounds(wgsGeometry);

            let mercGeometry =
            {
                type: wgsGeometry.type,
                coordinates: this.transformPointsStructureFromWGS(wgsGeometry.coordinates)
            }

            this.setState({
                dataset: dataset,
                geometry: mercGeometry,
                mapPosition: { lon: (bounds[0] + bounds[1]) / 2, lat: (bounds[2] + bounds[3]) / 2 },
                scaleIndex: 19
            });
        }
        else {
            this.setState({
                dataset: dataset,
                geometry: null,
                mapPosition: { lon: 50, lat: 53 },
                scaleIndex: 12
            });
        }

    }

    getBounds = (geometry) => {
        let minLon = 10000;
        let maxLon = -10000;
        let minLat = 10000;
        let maxLat = -10000;

        this.applyToEachPoint(geometry.coordinates,
            (x, y) => {
                if (x < minLon) minLon = x;
                if (x > maxLon) maxLon = x;
                if (y < minLat) minLat = y;
                if (y > maxLat) maxLat = y;
            },
            (points) => { return null; }
        );

        return [minLon, maxLon, minLat, maxLat];
    }

    transformPointsStructureFromWGS = (structure) => {
        if (typeof (structure) !== "object") {
            return null
        }
        if ((structure.length === 2) && (typeof (structure[0]) === "number") && (typeof (structure[1]) === "number")) {
            return fromLonLat(structure);
        }
        else {
            let newStructure = [];
            structure.forEach((item) => {
                let newItem = this.transformPointsStructureFromWGS(item);
                if (newItem) {
                    newStructure.push(newItem);
                }
            });
            return newStructure;
        }
    }

    transformPointsStructureToWGS = (structure) => {
        if (typeof (structure) !== "object") {
            return null
        }
        if ((structure.length === 2) && (typeof (structure[0]) === "number") && (typeof (structure[1]) === "number")) {
            return toLonLat(structure);
        }
        else {
            let newStructure = [];
            structure.forEach((item) => {
                let newItem = this.transformPointsStructureToWGS(item);
                if (newItem) {
                    newStructure.push(newItem);
                }
            });
            return newStructure;
        }
    }

    applyToEachPoint = (structure, funcForEach, funcForSet) => {
        if (typeof (structure) !== "object") {
            return null;
        }
        if ((structure.length === 2) && (typeof (structure[0]) === "number") && (typeof (structure[1]) === "number")) {
            return funcForEach(structure[0], structure[1]);
        }
        else {
            let set = structure.map((part) => { return this.applyToEachPoint(part, funcForEach, funcForSet) });
            return funcForSet(set);
        }
    }

    getStyleForGeometryType = (type) => {
        if ((type === 'Point') || (type === 'MultiPoint')) {
            return new Style({
                image: new Icon({
                    anchor: [12, 30],
                    width: 27,
                    height: 32,
                    anchorXUnits: 'pixels',
                    anchorYUnits: 'pixels',
                    src: "https://rk.geosamara.ru" + '/wfs/styles/legend?scale=1.5&styleName=' + 'simplepoint',
                })
            })

        } else if ((type === 'Polygon') || (type === 'MultiPolygon')) {
            return new Style({
                stroke: new Stroke({
                    color: "#FF0000",
                    width: 1
                }),
                fill: new Fill({
                    color: "#FF000080",
                })
            })

        } else if ((type === 'LineString') || (type === 'MultiLineString')); {
            return new Style({
                stroke: new Stroke({
                    color: "#FF0000",
                    width: 2
                })
            })
        }
        return new Style(null);
    }

    render() {
        let vectorSource = null;
        let editor = null;

        let preFeatures = [];

        if (this.state.geometry) {
            preFeatures.push({
                type: 'Feature',
                geometry: this.state.geometry,
                properties: {}
            });
        }

        let features = new GeoJSON().readFeatures(
            {
                type: 'FeatureCollection',
                crs: {
                    type: 'name',
                    properties: {
                        name: 'EPSG:3857',
                    },
                },
                features: preFeatures
            },
            { dataProjection: 'EPSG:3857' }
        );

        let source = vector({
            features: features
        });

        if (this.state.geometry) {
            editor = new Modify({ source: source });

            let realThis = this;
            editor.on('modifyend', function (event) {
                event.features.forEach(function (feature) {
                    let geometry = realThis.state.geometry;
                    geometry.coordinates = event.features.getArray()[0].getGeometry().getCoordinates();
                    realThis.setState({
                        geometry: geometry
                    });
                });
            });

        } else {
            editor = new Draw({
                source: source,
                type: "Polygon",
            });

            let realThis = this;
            editor.on('drawend', function (event) {
                let geometry = {
                    type: "Polygon",
                    coordinates: event.feature.getGeometry().getCoordinates()
                }
                realThis.setState({
                    geometry: geometry
                });
            });
        }

        vectorSource = {
            vector: source,
            style: this.getStyleForGeometryType(this.state.geometry ? this.state.geometry.type : "Polygon"),
        };


        return (
            <div className='twoHalfs' >
                <div id={"GeometryEditor"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}

                    <LeftPanelHeader
                        dataset={this.state.dataset}
                        sectionName={this.sectionName(actionTypes.GEOMETRY_EDITOR)}
                    />

                    <div className="postHeaderContainer textRoboto infoContainer">
                        {this.state.mapPosition && this.state.scaleIndex &&
                            <Map
                                mapRef={this.mapRef}
                                center={fromLonLat([this.state.mapPosition.lon, this.state.mapPosition.lat])}
                                zoom={this.state.scaleIndex}
                                interactions={defaultInteractions().extend([editor])}
                            >
                                <TileLayer
                                    source={new xyz({
                                        url: 'http://a.tile.openstreetmap.org/{z}/{x}/{y}.png'
                                    })}
                                />
                                {vectorSource &&
                                    <VectorLayer
                                        source={vectorSource.vector}
                                        style={vectorSource.style}
                                    />
                                }
                            </Map>
                        }
                    </div>
                    {(!this.state.runningOperation) && this.state.geometry &&
                        <Button
                            className='applyInstrument'
                            onClick={() => {
                                this.setState({ runningOperation: true }, () => {
                                    let wgsGeometry =
                                    {
                                        type: this.state.geometry.type,
                                        coordinates: this.transformPointsStructureToWGS(this.state.geometry.coordinates)
                                    }
                                    this.props.onSave(wgsGeometry);
                                });
                            }}
                        >Сохранить</Button>
                    }
                </div>

                <div className='rightHalf'></div>
            </div>
        );
    }
}

